import { io } from 'socket.io-client';
import { SOCKET_BASE_URL, SOCKET_API_KEY } from '../config';

let socket;

export function getSocket() {
  if (socket) return socket;
  const token = localStorage.getItem('token');
  const url = (SOCKET_BASE_URL || window.location.origin).replace(/\/$/, '');
  socket = io(url, {
    transports: ['websocket'],
    autoConnect: true,
    auth: SOCKET_API_KEY ? { apiKey: SOCKET_API_KEY } : (token ? { token } : {}),
  });
  return socket;
}

export function disconnectSocket() {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
